import { ListItem, Stack, Typography, Chip } from '@mui/material'
import { AssigneeEntity } from '@omnea-app/core/blocks'
import { AssigneeTypeEnum } from '@omnea-app/packages/universal/hasura/graphql'

type AssigneeAutocompleteOptionProps = {
  option: AssigneeEntity
  hideChip?: boolean
}

export const AssigneeAutocompleteOption = ({ option, hideChip, ...props }: AssigneeAutocompleteOptionProps) => {
  const isVariableQuestionOption = option.type === AssigneeTypeEnum.VARIABLE
  const assigneeOptionLabel = getAssigneeLabelName(option)

  if (isVariableQuestionOption) {
    return (
      <ListItem {...props}>
        <Stack flexDirection="row" sx={{ justifyContent: 'space-between', alignItems: 'center', width: '100%' }}>
          <Typography sx={{ mr: 1, lineHeight: '28px' }}>{assigneeOptionLabel}</Typography>
          {!hideChip && <Chip label={option.id} />}
        </Stack>
      </ListItem>
    )
  }

  return (
    <ListItem {...props}>
      <Typography sx={{ mr: 1, lineHeight: '28px' }}>{assigneeOptionLabel}</Typography>
      {option.title && (
        <Typography variant="Body12pxRegular" color="neutral.main">
          ({option.title})
        </Typography>
      )}
    </ListItem>
  )
}

const getAssigneeLabelName = (option: AssigneeEntity) => {
  // Should never happen
  if (typeof option === 'string') {
    return option
  }

  return `${option.name ?? option.value}${option.email ? ` [${option.email}]` : ''}`
}
